import { ElementType, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CategoryDistributionCardSkeleton } from './CategoryDistributionCardSkeleton';

import { Tooltip } from '@/components';
import { CATEGORY_DISTRIBUTION_CARD_TEST_IDS } from '@/constants/data-testids';
import { cn } from '@/utils/tailwind';

import { Card, CardContent } from '../../atoms/Card/Card';

type CategoryDistributionCardProps = {
  title: string;
  questionsCount: number;
  icon?: ElementType;
  isLoading?: boolean;
  tooltipTitle?: string;
  className?: string;
};

export const CategoryDistributionCard: FC<CategoryDistributionCardProps> = ({
  title,
  questionsCount,
  tooltipTitle,
  isLoading,
  icon: Icon,
  className,
}) => {
  const { t } = useTranslation('components');

  if (isLoading) {
    return <CategoryDistributionCardSkeleton />;
  }

  return (
    <Card className={cn('rounded-[12px] w-[160px] h-[76px] px-4 py-3', className)}>
      <CardContent className="h-full flex flex-col">
        <div className="flex items-center justify-between gap-1 mb-1.5 h-full">
          <p className="text-body-12-medium text-custom-warm-grey-800 line-clamp-2">{title}</p>
          <Tooltip title={tooltipTitle}>
            {Icon && (
              <Icon
                className="text-custom-orange-600"
                width={16}
                height={16}
                data-testid={CATEGORY_DISTRIBUTION_CARD_TEST_IDS.ICON}
              />
            )}
          </Tooltip>
        </div>
        <p className="text-body-12-regular text-custom-warm-grey-500">
          {t('categoryDistributionCard.questionsCount', { count: questionsCount })}
        </p>
      </CardContent>
    </Card>
  );
};
